var $ = require('jquery');

window.MarketoUtilities = {
    wrapLabelContent: function (obj) {
        if (obj.length) {
            var contentElements = obj;
            $.each(contentElements, function () {
                var content = this.innerHTML;
                if (content !== 'undefined' && content !== '' && !content.startsWith('<p')) {
                    this.innerHTML = '<p>' + content + '</p>';
                }
            });
        }
    },

    allUrlParams: function () {
        var urlParams;
        var match,
            pl = /\+/g,
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) { return decodeURIComponent(s.replace(pl, " ").replace("_", "")); },
            query = window.location.search.substring(1);

        urlParams = {};
        while (match = search.exec(query))
            urlParams[decode(match[1])] = decode(match[2]);

        return urlParams;
    },

    allCookieParams: function () {
        var cookieParams;
        var match,
            pl = /\+/g,
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) { return decodeURIComponent(s.replace(pl, " ").replace("_", "")); },
            query = window.GenericUtilities.getCookieByName("CroweLLP_session");

        cookieParams = {};
        while (match = search.exec(query))
            cookieParams[decode(match[1])] = decode(match[2]);

        return cookieParams;
    },

    prefillFields: function (obj) {
        if (obj.length) {
            var contentElements = obj;
            var urlParams = MarketoUtilities.allUrlParams();
            var cookieParams = MarketoUtilities.allCookieParams();
            $.each(contentElements, function (index, element) {
                var elementNameLower = element.name.toLowerCase();
                if (urlParams[element.name]) {
                    if (elementNameLower === 'contact') {
                        $.ajax({
                            type: "GET",
                            url: '/api/sitecore/ContactDetails/GetContactName',
                            traditional: true,
                            data: {
                                guid: urlParams[element.name]
                            },
                            success: function (data) {
                                element.value = data;
                            },
                            error: function (e) {
                            },
                            complete: function (e) {
                            }
                        });
                    }
                }

                if (cookieParams[elementNameLower]) {
                    if (Object.keys(urlParams) == 0) {
                        element.value = cookieParams[elementNameLower];
                    } else if (typeof urlParams[elementNameLower] === 'undefined') {
                        element.value = cookieParams[elementNameLower];
                    }
                }
            });
        }
    }
}